// F-14: Minimal HTML sanitizer for content rendered with v-html.
//
// The error-message strings in the app intentionally contain simple <br>
// line breaks, which is why they are bound with v-html. This helper escapes
// ALL HTML first (so any injected markup — <script>, <img onerror=...>, etc.
// — is neutralised) and then re-allows only <br> / <br/> tags, preserving the
// intended formatting without opening an XSS sink.
export function sanitizeBr(input) {
  const escaped = String(input == null ? "" : input)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
  // Re-allow only simple line-break tags.
  return escaped.replace(/&lt;br\s*\/?&gt;/gi, "<br>");
}

export default sanitizeBr;
